var $registerStepsErrorMsg = 'Default Error Message';
var $registerStepsSubmits = document.querySelectorAll('[sh-component=step-submit]');
var $registerStepsMenu = document.querySelectorAll('.page-register-menu-breadcrumb-step');
var $registerStepsMainMenu = document.querySelectorAll('.showInfos .page-register-menu-main-item');
var $registerModal;
var getUrl = window.location;
var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];
var sessionSerial = null;
var currentStep = 1;
var numberResults = 3;
var player = null;

function registerTestPosStep()
{
    if ($registerStepsSubmits === null || $registerStepsSubmits.length === 0) return false;
    for ($i = 1; $i <= $registerStepsSubmits.length; $i++) {
        var __step = document.querySelector("#step" + $registerStepsSubmits[($i - 1)].getAttribute('sh-data'));
        if (!__step.parentNode.classList.contains('__displayed')) continue;
        if (__step.getBoundingClientRect().top - 50 < 0) {
            $registerStepsMenu[($i - 1)].classList.add('__current');
            $registerStepsMainMenu[($i - 1)].classList.add('__current');
        }
        else {
            $registerStepsMenu[($i - 1)].classList.remove('__current');
            $registerStepsMainMenu[($i - 1)].classList.remove('__current');
        }
    }
}

function registerCompileFields($__step_id)
{
    var __inputs = document.querySelectorAll('input[name=__check' + $__step_id + ']');
    if (__inputs == null && __inputs.length == 0) return '';
    var __tmp = new Array();
    for ($i = 0; $i < __inputs.length; $i++) {
        if (__inputs[$i].checked) __tmp.push(__inputs[$i].value);
    }
    return __tmp.join(',');
}

function getCookieValue (name)
{
    return document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)')?.pop() || ''
}

var handleLoading = function (action)
{
    var containerLoading = document.querySelector('#loading')
    if (action == 'show')
    {
        containerLoading.classList.add('z-index')
        setTimeout(function ()
        {
            containerLoading.classList.add('show')
        }, 50)
    }
    else
    {
        containerLoading.classList.remove('show')
        setTimeout(function ()
        {
            containerLoading.classList.remove('z-index')
        }, 500)
    }
}

function registerMatchmaking()
{
    var storedCookie = getCookieValue("stepReco");
    if(storedCookie === '' ||storedCookie.length < 10)
    {
        var form = serialize(document.querySelector('#register-form'));
        form['motivations'] = registerCompileFields(1);
        storedCookie = JSON.stringify(form);
        document.cookie = "stepReco=" + storedCookie;
    }
    var data = new FormData();
    data.append("data", storedCookie);
    var container = document.querySelector(".psys_list .matchmaking-list");

    fetch(baseUrl + '/ajax/matchmaking',
        {
            method: "POST",
            credentials: 'include',
            body:data
        }
    ).then(function (res)
    {
        return res.json()
    }).then(function (res)
    {
        var psys = res.result;
        container.innerHTML = '';
        for (var i = 0; i < psys.length; ++i)
        {
            var clone = registerClone_item(psys[i]);
            var _href = clone.querySelector(".show-more").getAttribute('data-href');
            _href = _href.replace(/{PRACTITIONER_REFERER}/i, psys[i].referer);
            clone.querySelector(".show-more").setAttribute('href', _href);
            container.appendChild(clone);
        }
    }).catch();
}

var handleFormValidation = function ()
{
    var valid = false;
//    console.log(currentStep)
    if(isNaN(currentStep)) return false;
    switch (currentStep)
    {
        case 1 :
        
            valid = true;
        
        break;
        case 2:

            var __fields = registerCompileFields(1);
            valid = __fields.length > 0 ? true : false;
            window.localStorage.removeItem("step2");
            if(valid)  window.localStorage.setItem("step2", __fields);
            $registerStepsErrorMsg = valid === false ? 'Veuillez sélectionner au moins une option' : "";
        
        break;
        case 3:

            var choice = document.querySelector("select[name=age]");
            if(choice.value == "") $registerStepsErrorMsg = 'Veuillez sélectionner une option';
            else valid = true;
            window.localStorage.removeItem("step3");
            if(valid) window.localStorage.setItem("step3", choice.value);

        break;
        case 4:

            var choice = document.querySelector("input[name=time]:checked");
            if (choice == null) $registerStepsErrorMsg = 'Veuillez sélectionner une option';
            else valid = true;
            window.localStorage.removeItem("step4");
            if(valid) window.localStorage.setItem("step4", choice.value);

        break;
        case 5:

            var choice = document.querySelector("input[name=psyMedia]:checked");
            if (choice == null) $registerStepsErrorMsg = 'Veuillez sélectionner une option';
            else valid = true;
            window.localStorage.removeItem("step5");
            if(valid) window.localStorage.setItem("step5", choice.value);

        break;

        case 6:

            var choice = document.querySelector("input[name=psyGender]:checked");
            if (choice == null) $registerStepsErrorMsg = 'Veuillez sélectionner une option';
            else valid = true;
            window.localStorage.removeItem("step6");
            if(valid) window.localStorage.setItem("step6", choice.value);

        break;
        case 7:

            var choice = document.querySelector("input[name=psyType]:checked");
            if (choice == null) $registerStepsErrorMsg = 'Veuillez sélectionner une option';
            else valid = true;
            window.localStorage.removeItem("step7");
            if(valid) window.localStorage.setItem("step7", choice.value);

        break;
    }
    return valid;
}


var registerTransition = function (step)
{
    document.querySelectorAll(".register-step").forEach(function(item){ item.style.display = "none"});
    document.querySelector("#step-" + step).style.display = "block";
    document.querySelector('[sh-component=main-wrapper]').scrollTo(0, 0)
    currentStep = parseInt(step);
    setTimeout(function ()
    {
        handleLoading("hide");
    }, 300)

    var state = step == 1 ? "none" : "flex";
    document.querySelector('#header-register .backBtn').style.display = state;
    document.querySelector('#header-register .backBtn').dataset.prev = step - 1;
}


var showPsyTypeInfos = function (element)
{
    var popin = document.querySelector('#registerPopin');
    fetch(baseUrl + '/ajax/showPsyTypeInfos',
        {
            method: "POST",
            credentials: 'include'
        }
    ).then(function (res)
    {
        return res.json()
    }).then(function (res)
    {
        if (res.success === true)
        {
            resetPopin('.popinText');
            popin.querySelector('.head .title').innerHTML = element.innerText;
            popin.querySelector('.textContent').innerHTML = res.formated_result;
            handleConfirmationAnim('show');
            popin.querySelector('.closeConfirmation').addEventListener('click', function(){ handleConfirmationAnim('hide') });
        }
    }).catch();
}

var handleClick = function (event)
{
    event = event || window.event;
    var element = event.target;
    while (element)
    {
        if (element.nodeName === "A" && /nextStep/.test(element.className))
        {
            event.preventDefault();
            var valid = handleFormValidation();
            Promise.resolve(valid).then(function (value)
            {
                if (value === false) {
                    $registerModal = new Modal({ content: $registerStepsErrorMsg });
                    $registerModal.on('show', function ($registerModal, event) { event; $registerModal._html.header.childNodes[0].remove(); $registerModal._html.footer.childNodes[0].remove() });
                    $registerModal.show();
                }
                else
                {
                    handleLoading("show");
                    document.cookie = "stepId=" + element.dataset.next;
                    setTimeout(function () {
                        if (element.dataset.next == 8 ) {
                            registerMatchmaking()
                        }
                        registerTransition(element.dataset.next)
                    }, 500)
                }
            })
            break;
        }
        if (element.nodeName === "A" && /backBtn/.test(element.className))
        {
            event.preventDefault();
            document.cookie = "stepId=" + element.dataset.prev;
            handleLoading("show");
            setTimeout(function ()
            {
                registerTransition(element.dataset.prev)
            }, 500)
            break;
        }
        if (element.nodeName === "A" && /psyTypeInfos/.test(element.className))
        {
            event.preventDefault();
            showPsyTypeInfos(element);
            break;
        }
        element = element.parentNode;
    }
};

var initRegisterReco = function()
{
    var l = document.querySelectorAll(".register-step").length;
    for(var i = 2; i <= l; i++)
    {
        var item = window.localStorage.getItem("step" + i);
        if(item != null)
        {
            switch(i)
            {
                case 2 :

                    var __datas = item.split(",");
                    var __inputs = document.querySelectorAll("#step-2 .page-register-options-item input[type=checkbox]");
                    for(var z in __inputs)
                    {
                        if(typeof(__inputs[z].value) === 'undefined') continue;
                        var __value = __inputs[z].value ;
                        if(__datas.includes(__value)) __inputs[z].checked = true;
                    }

                break;

                case 3 :

                    var __inputs = document.querySelectorAll("#step-3 #f_topic_age option");
                    for(var z in __inputs)
                    {
                        if(typeof(__inputs[z].value) === 'undefined') continue;
                        var __value = __inputs[z].value ;
                        if(item == __value)
                        {
                            __inputs[z].selected = true;
                            document.querySelectorAll("#step-3 #f_topic_age").selectedIndex = z;
                        }
                    }

                break;

                case 4 :
                case 5 :
                case 6 :
                case 7 :

                    var __inputs = document.querySelectorAll("#step-" + i + " input[type=radio]");
                    for(var z in __inputs)
                    {
                        if(typeof(__inputs[z].value) === 'undefined') continue;
                        var __value = __inputs[z].value ;
                        if(item == __value) __inputs[z].checked = true;
                    }

                break;
            }
        }
    }
}

var resetRegisterReco = function()
{
    document.cookie="stepId=1"; 
    document.cookie="stepReco=none";
    //
    var l = document.querySelectorAll(".register-step").length;
    for(var i = 2; i <= l; i++)
    {
        var item = window.localStorage.getItem("step" + i);
        if(item != null)
        {
            window.localStorage.removeItem("step" + i);
        }
    }

}

if (document.querySelector(".register"))
{
    if (document.querySelector('.psys_list') && document.querySelector('.psys_list').style.display !== 'none')
    {
        registerMatchmaking()
    }
    document.addEventListener("click", handleClick, false);
    var storedCookie = getCookieValue("stepId");

    var __step = parseInt(storedCookie) ;
    if(!isNaN(__step)) currentStep = __step;
    //
    document.querySelectorAll('.inner-close-btn').forEach(function(item) { item.addEventListener('click', function(event){ resetRegisterReco(); })});
    document.querySelectorAll('.__reset').forEach(function(item) { item.addEventListener('click', function(event){ resetRegisterReco(); })});
    //
    initRegisterReco();
}
